import React from 'react'
import { Menu, Icon } from 'antd'
import menuConfig from '../../constants/menu'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const MenuItemGroup = Menu.ItemGroup

const SideMenu = ({ history, profile }) => {
  return (
    <Menu 
      mode="inline"
      onClick={(e) => history.push(e.key)}
      selectedKeys={[window.location.pathname]}
      defaultSelectedKeys={[menuConfig.DEFAULT]}>
      {menuConfig.MENU.map((group, i) => {
        if(group.role) {
          if(!group.role.includes(profile.role)) {
            return null
          }
        }

        return (
          <MenuItemGroup title={group.name} key={`${i}`}>
            {group.menus.map((value, j) => {
              if(value.role) {
                if(!value.role.includes(profile.role)) {
                  return null
                }
              }

              return (
                <Menu.Item key={value.path || j}>
                  <Icon type={value.icon}/>
                  <span>{value.title}</span>
                </Menu.Item>
              )
            })}
          </MenuItemGroup>
        )
      })}
    </Menu>
  )
}

export default withRouter(connect(
  state => ({
    profile: state.auth.loginUser
  })
)(SideMenu))



// WEBPACK FOOTER //
// ./src/components/Menu/index.js